import React from 'react';
import './AboutUs.css';
import carwashImg from '../assets/about1.png'; // placeholder, replace with your image
import carImg from '../assets/About-car.png'; // placeholder, replace with your image
import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';

const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <section className="aboutus-section container">
      <div className="aboutus-left">
        <div className="aboutus-garage-img">
          <img src={carwashImg} alt="Drive-In Car Spa" />
        </div>
        <div className="aboutus-car-row">
          <img className="aboutus-car-img" src={carImg} alt="Car" />
          <div className="aboutus-orange-label">
            Speed Meets<br />Precision – Trusted<br />by India’s Car Experts.
          </div>
        </div>
      </div>
     <div className="aboutus-right">
  <h2 className="aboutus-title">
    Efficiency Meets Innovation – Premium Car Spa in Bangalore
  </h2>

  <div className="aboutus-desc">
    Welcome to a new standard in automotive care. Drive-In Car Spa, introduced by Arkiya Innovations LLP, brings you a  <Link to="/contact" className="link-text">premium car spa in Bangalore</Link> with its fully automated Premium Plus system—an advanced automatic car wash manufacturer product made for dealerships, franchises, and car lovers across India.
  </div>

  <div className="aboutus-bold">
  </div>

  <div className="aboutus-desc">
    As a trusted premium car spa in Bangalore, we reduce wash time to just 6–10 minutes, helping you serve more customers, cut operational costs, and improve satisfaction—all with eco-conscious, low-chemical, and water-efficient solutions.
  </div>

  <button className="aboutus-services-btn" onClick={() => navigate('/about')}>
    About us
  </button>
</div>
    </section>
  );
};

export default AboutUs; 